<template>
  <div
    v-show="open"
    class="wtv-calendar-container"
    :class="{ 'is-single': !hasSecondDate && !hasYear }"
  >
    <div class="wtv-calendar-table">
      <div class="wtv-calendar-year-container" v-if="hasYear">
        <div class="wtv-calendar-nav-title" v-html="currentYearString"></div>
        <div class="wtv-calendar-nav-forward wtv-icon" @click="() => nav(12 * 10)"></div>
        <div class="wtv-calendar-nav-back wtv-icon" @click="() => nav(-12 * 10)"></div>
        <div class="wtv-calendar-year-grid">
          <div
            v-for="year in currentYearList"
            :key="year"
            :class="{
              active: isActiveYear(year),
            }"
            @click="() => setYear(year)"
            class="wtv-calendar-year"
          >{{ year }}</div>
        </div>
        <div style="width: 4px" v-if="hasYear"></div>
      </div>

      <div class="wtv-calendar-month-container">
        <div class="wtv-calendar-nav-forward wtv-icon" @click="() => nav(1)"></div>
        <div class="wtv-calendar-nav-back wtv-icon" @click="() => nav(-1)"></div>
        <div class="wtv-calendar-nav-title" v-html="currentMonths"></div>
        <div class="wtv-calendar-month">
          <div v-for="day in i18n.day" :key="day" class="wtv-calendar-week">{{ day }}</div>
          <template v-if="getInactiveDays(state.currentDate)">
            <div
              v-for="iday in getInactiveDays(state.currentDate)"
              :key="'i' + iday"
              class="wtv-calendar-day-inactive"
            ></div>
          </template>
          <div
            v-for="day in daysInMonth(state.currentDate)"
            :key="day"
            :class="{
              active: isActive(day, state.currentDate),
              focused: isFocused(day, state.currentDate),
              disabled: isDisabled(day, state.currentDate),
            }"
            class="wtv-calendar-day"
            @mouseover="() => setFocused(day, state.currentDate)"
            @mouseout="() => setFocused()"
            @click="() => setDate(day, state.currentDate)"
          >{{ day }}</div>
        </div>
      </div>

      <div style="width: 4px" v-if="hasSecondDate"></div>

      <div class="wtv-calendar-month-container" v-if="hasSecondDate">
        <div class="wtv-calendar-nav-title" v-html="nextMonths"></div>
        <div class="wtv-calendar-month">
          <div v-for="day in i18n.day" :key="day" class="wtv-calendar-week">{{ day }}</div>
          <template v-if="getInactiveDays(nextDate)">
            <div
              v-for="iday in getInactiveDays(nextDate)"
              :key="'i' + iday"
              class="wtv-calendar-day-inactive"
            ></div>
          </template>
          <div
            v-for="day in daysInMonth(nextDate)"
            :key="day"
            :class="{
              active: isActive(day, nextDate),
              focused: isFocused(day, nextDate),
              disabled: isDisabled(day, nextDate),
            }"
            class="wtv-calendar-day"
            @mouseover="() => setFocused(day, nextDate)"
            @mouseout="() => setFocused()"
            @click="() => setDate(day, nextDate)"
          >{{ day }}</div>
        </div>
      </div>
    </div>
    <!-- <div class="wtv-calendar-footer" v-if="hasSecondDate">
      <div
        class="wtv-icon wtv-icon-radio"
        :class="{ 'is-selected': state.isSettingDateFrom }"
        @click="state.isSettingDateFrom = true"
      >Туда</div>
      <div
        class="wtv-icon wtv-icon-radio"
        :class="{ 'is-selected': !state.isSettingDateFrom }"
        @click="state.isSettingDateFrom = false"
      >Обратно</div>
      <div
        class="wtv-button-third"
        style="margin: 0"
        @click="handleNoReturnClick"
      >Обратный билет не нужен</div>
    </div> -->
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  watch,
  reactive,
  computed,
} from 'vue';
import { useStore } from 'vuex';
import { i18n, stringFromDate } from '@/functions';

export default defineComponent({
  props: {
    open: Boolean,
    onSelect: Function,
    onDateSelect: {
      type: Function,
      required: true,
    },
    df: Date,

    hasDisabled: { type: Boolean, default: true },
    hasSecondDate: Boolean,
    hasYear: Boolean,
    onSecondDateSelect: Function,
  },
  setup(props) {
    const $store = useStore();
    const state = reactive({
      isSettingDateFrom: true,
      currentDate: new Date(
        new Date(new Date().setDate(1)).setHours(12, 0, 0, 0),
      ),
      focusedDates: [],
      i18n,
    });
    // !!!
    // date bug
    // SOLUTION: (as unknown) as Date
    const df = computed(() => (props.df as unknown) as Date);
    const dt = computed(() => (props.hasSecondDate
      ? (new Date($store.state.initials.common.dateto) as Date)
      : null));
    const datefrom = computed(() => (df.value ? df.value?.toLocaleDateString('ru-RU') : ''));
    // const dateto = computed(() => (props.hasSecondDate && dt.value
    //   ? dt.value.toLocaleDateString('ru-RU')
    //   : ''));
    const updateDateFrom = (date: Date): void => {
      props.onDateSelect({ date });
      if (!props.hasSecondDate && props.onSelect) {
        props.onSelect();
        return;
      }
      state.isSettingDateFrom = false;
    };
    const updateDateTo = (date: Date): void => {
      if (props.onSecondDateSelect) props.onSecondDateSelect({ date });
      state.isSettingDateFrom = true;
    };

    // text getters
    const getLocaleMonth = (date: Date): string => (
      [i18n.month[date.getMonth()].slice(0, 3), date.getFullYear()]
        .join(
          ' ',
        )
    );

    // state checks
    const isActive = (day: number, date: Date): boolean => {
      const dateCopy = new Date(date);
      const dateString = stringFromDate(new Date(dateCopy.setDate(day)));
      if (dateString === (datefrom.value as string)) return true;

      if (!dt.value) return false;

      return (state.focusedDates as number[]).includes(dateCopy.setDate(day));
    };
    const isDisabled = (day: number, date: Date): boolean => (props.hasDisabled
      ? new Date(new Date(date).setDate(day)).getTime() < new Date().getTime()
      : false);
    const isFocused = (day: number, date: Date): boolean => {
      if (isDisabled(day, date)) return false;
      const dateCopy = new Date(date);
      return (state.focusedDates as number[]).includes(dateCopy.setDate(day));
    };

    // service getters;
    const nextMonth = (date: Date, index = 1): Date => {
      const dateCopy = new Date(date);
      return new Date(dateCopy.setMonth(dateCopy.getMonth() + index));
    };
    const nextDate = computed(() => nextMonth(state.currentDate as Date));
    const currentMonths = computed(() => getLocaleMonth(state.currentDate as Date));
    const nextMonths = computed(() => getLocaleMonth(nextDate.value as Date));
    // const inactiveDays = computed(() => getInactiveDays(state.currentDate as Date))
    const getInactiveDays = (date: Date): number => {
      const dateCopy = new Date(date);
      const day = new Date(dateCopy.setDate(1)).getDay() - 1;
      return day >= 0 ? day : 6;
    };
    const daysInMonth = (date: Date): number => {
      const dateCopy = new Date(date);
      return (
        33 - new Date(dateCopy.getFullYear(), dateCopy.getMonth(), 33).getDate()
      );
    };

    // year
    const isActiveYear = (year: number) => state.currentDate.getFullYear() === year;
    const currentYearString = computed(() => {
      const currentYear = state.currentDate.getFullYear();
      const currentYearStart = Math.floor(currentYear / 10) * 10;
      return `${currentYearStart} - ${currentYearStart + 10}`;
    });
    const currentYearList = computed(() => {
      const currentYear = state.currentDate.getFullYear();
      let currentYearStart = Math.floor(currentYear / 10) * 10;
      return [...Array(10)].map(() => {
        currentYearStart += 1;
        return currentYearStart;
      });
    });
    const setYear = (year: number) => {
      state.currentDate = new Date(state.currentDate.setFullYear(year));
    };

    // methods
    const setDate = (day: number, date: Date): void => {
      if (isDisabled(day, date)) return;
      const dateCopy = new Date(date);
      dateCopy.setDate(day);
      if (state.isSettingDateFrom) {
        updateDateFrom(dateCopy);
        return;
      }

      updateDateTo(dateCopy);
      if (props.onSelect) props.onSelect();
    };
    const nav = (index: number): void => {
      state.currentDate = nextMonth(state.currentDate as Date, index);
    };
    const collectFocused = (a: number, b: number = a) => {
      const from = Math.min(a, b);
      const to = Math.max(a, b);
      const focused = [];

      for (let time = from; time <= to; time += 86400000) focused.push(time);
      (state.focusedDates as number[]) = focused;
    };
    const setFocused = (day: number, date: Date) => {
      if (state.isSettingDateFrom) return;

      if (!day) state.focusedDates = [];
      collectFocused(
        (df.value as Date).getTime(),
        new Date(new Date(date).setDate(day)).getTime(),
      );
    };

    // no return
    const handleNoReturnClick = () => {
      state.isSettingDateFrom = true;
      $store.commit('updateSegment', { index: 1, segment: { date: null } });
      collectFocused(df.value.getTime());
      if (props.onSelect) props.onSelect();
    };

    // created
    const initialize = () => {
      if (!df.value) return;
      collectFocused(df.value.getTime());
    };
    initialize();

    // nav to valid month
    if (daysInMonth(state.currentDate as Date) === state.currentDate.getDate()) { nav(1); }
    watch(
      () => props.open,
      () => {
        if (!state.currentDate || !df.value) return;
        while (state.currentDate.getMonth() < df.value.getMonth()) nav(1);
        while (state.currentDate.getFullYear() < df.value.getFullYear()) { nav(12); }
        while (state.currentDate.getMonth() > df.value.getMonth()) nav(-1);
        while (state.currentDate.getFullYear() > df.value.getFullYear()) { nav(-12); }
      },
    );

    // remove focus if isComposite
    watch(
      () => props.hasSecondDate,
      () => df.value && collectFocused(df.value.getTime()),
    );
    return {
      state,
      i18n,
      nextDate,
      currentMonths,
      nextMonths,
      getInactiveDays,
      daysInMonth,
      isActive,
      isFocused,
      isDisabled,
      // isSettingDateFrom,
      setFocused,
      setDate,
      nav,
      handleNoReturnClick,

      currentYearString,
      currentYearList,
      setYear,
      isActiveYear,
    };
  },
});
</script>

<style scoped>
.wtv-calendar-container {
  width: 470px;
  z-index: 1;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: var(--color-bg-dark);
  box-shadow: 0 0 1px var(--color-alt), 0 0 8px var(--color-bg-dark),
    1px 0 12px var(--color-bg);
}
@media (max-width: 575px) {
  .wtv-calendar-container {
    width: 233px;
  }
}
.wtv-calendar-container.is-single {
  width: 233px;
}
.wtv-calendar-nav {
  width: 100%;
  margin-bottom: 12px;
  display: grid;
  grid-template-columns: 32px 1fr 32px;
  align-items: center;
  justify-items: center;
  height: 32px;
  line-height: 32px;
  background-color: var(--color-bg-dark);
}
.wtv-calendar-nav-back,
.wtv-calendar-nav-forward {
  width: 32px;
  display: flex;
  justify-content: center;
  cursor: pointer;
  position: absolute;
}
.wtv-calendar-nav-forward {
  right: 0;
}
.wtv-calendar-nav-back:before,
.wtv-calendar-nav-forward:before {
  content: '\f053';
  align-self: stretch;
  font-size: 24px;
  width: 100%;
  padding: 4px;
  vertical-align: middle;
  background-color: var(--color-alt-5);
  color: var(--color-main);
  text-align: center;
}
.wtv-calendar-nav-forward:before {
  content: '\f054';
}
.wtv-calendar-nav-title {
  font-size: 13px;
  white-space: nowrap;
  height: 32px;
  line-height: 32px;
  text-align: center;
}
.wtv-calendar-table {
  width: 470px;
  display: flex;
  flex-wrap: wrap;
  background-color: var(--color-bg-dark);
  position: relative;
}
@media (max-width: 575px) {
  .wtv-calendar-table {
    width: 233px;
  }
}
.is-single > .wtv-calendar-table {
  width: 233px;
}
.wtv-calendar-month {
  flex: 1 0 calc(50% - 4px);
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-template-rows: repeat(7, 32px);
  grid-gap: 1px;
}
.wtv-calendar-month-container,
.wtv-calendar-year-container {
  flex: 1 0 233px;
  position: relative;
}
.wtv-calendar-year-container {
  padding: 32px;
}
.wtv-calendar-year-container .wtv-calendar-nav-title {
  background-color: var(--color-bg);
}
.wtv-calendar-year-container .wtv-calendar-nav-back {
  top: 32px;
  left: 32px;
}
.wtv-calendar-year-container .wtv-calendar-nav-forward {
  top: 32px;
  right: 32px;
}
/* .wtv-calendar-month:first-child {
  margin-right: 4px;
}
.wtv-calendar-month:last-child {
  margin-left: 4px;
} */
.wtv-calendar-week {
  height: 32px;
  line-height: 32px;
  text-align: center;
  background-color: var(--color-bg);
}
.wtv-calendar-year-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 1px;
  flex: 1 0 calc(50% - 4px);
}
.wtv-calendar-day,
.wtv-calendar-year {
  text-align: center;
  height: 32px;
  line-height: 32px;
  background-color: #fff;
  cursor: pointer;
}
.wtv-calendar-year {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 0 8px;
}
.wtv-calendar-day.focused {
  background-color: var(--color-alt-5);
}
.wtv-calendar-day.disabled {
  background-color: var(--color-bg-dark);
  color: var(--color-alt-5);
  outline: none;
  cursor: default;
}
.wtv-calendar-year.active,
.wtv-calendar-day.active {
  background-color: var(--color-main);
  color: #fff;
}
.wtv-calendar-day:hover {
  outline: 1px solid var(--color-main);
  background-color: var(--color-alt-5);
  color: var(--color-text);
}
.wtv-calendar-day-inactive {
  height: 24px;
  line-height: 24px;
}
.wtv-calendar-footer {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding: 4px;
  margin-top: 8px;
}
</style>
